import { Component, Input } from '@angular/core';

@Component({
  selector: 'usb-popup',
  templateUrl: './usb-popup.component.html',
  styleUrls: ['./usb-popup.component.scss']
})

export class UsbPopupComponent {
  @Input() isLoading = false;
  @Input() iconUrl: string = null;
  @Input() popupClass: string = '';
  @Input() showAlways = false;
}
